export class CargoInsuranceCommodityExclusionDetail {
  id: string;
  name: string;
  description: string;

  constructor(opts: { id: string; name: string; description: string }) {
    this.id = opts.id;
    this.name = opts.name;
    this.description = opts.description;
  }
}
